// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"Media_imageWrapper__19PNR"};